import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerPickerComponent } from './customer-picker.component';
import { TranslateModule } from '@client/app/modules/translate.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { ComponentsModule } from '@client/app/components/components.module';

@NgModule({
    declarations: [
        CustomerPickerComponent,
    ],
    imports: [
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        TranslateModule,
    ],
    exports: [
        CustomerPickerComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerPickerModule { }
